import React from 'react';
import logo1 from '../assets/partenaires/esa-consultance-logo-1.png';
import logo2 from '../assets/partenaires/images.jpg';
import logo3 from '../assets/partenaires/WhatsApp Image 2026-08-03 at 2.27.50 PM.jpeg';

const partenaires = [
  { nom: 'ESA Consultance', logo: logo1 },
  { nom: 'Partenaire 2',    logo: logo2 },
  { nom: 'Partenaire 3',    logo: logo3 },
];

const liste = [...partenaires, ...partenaires, ...partenaires, ...partenaires];

function Partenaires() {
  return (
    <section className="py-16 overflow-hidden" style={{ background: '#f8f8f8' }}>

      {/* Header */}
      <div className="text-center mb-10">
        <p className="font-bold text-2xl" style={{ color: '#0F0F2D' }}>
          Ils nous font <span style={{ color: '#1A1AE6' }}>confiance</span>
        </p>
        <div className="w-12 h-1 mx-auto mt-3 rounded-full" style={{ background: '#1A1AE6' }}></div>
      </div>

      {/* Carousel avec pause */}
      <div className="relative flex overflow-hidden">

        {/* Dégradé gauche */}
        <div className="absolute left-0 top-0 h-full w-32 z-10"
          style={{ background: 'linear-gradient(90deg, #f8f8f8, transparent)' }}>
        </div>

        {/* Logos défilants */}
        <div
          className="flex items-center gap-20"
          style={{ animation: 'scroll 12s linear infinite' }}
        >
          {liste.map((partenaire, index) => (
            <div
              key={index}
              className="flex-shrink-0 flex items-center justify-center transition-all duration-300 hover:scale-110"
              style={{ minWidth: '160px' }}
            >
              <img
                src={partenaire.logo}
                alt={partenaire.nom}
                className="object-contain"
                style={{ height: '70px', width: 'auto', maxWidth: '160px' }}
              />
            </div>
          ))}
        </div>

        {/* Dégradé droite */}
        <div className="absolute right-0 top-0 h-full w-32 z-10"
          style={{ background: 'linear-gradient(270deg, #f8f8f8, transparent)' }}>
        </div>

      </div>

      <style>{`
        @keyframes scroll {
          0%   { transform: translateX(0); }
          90%  { transform: translateX(-50%); }
          90.01% { opacity: 1; }
          95%  { opacity: 0; transform: translateX(-50%); }
          95.01% { transform: translateX(0); opacity: 0; }
          100% { transform: translateX(0); opacity: 1; }
        }
      `}</style>

    </section>
  );
}

export default Partenaires;